export enum CredentialEntity {
  CrossAccountApp = 'CrossAccountApp',
  ExternalApp = 'ExternalApp',
  ManagedApp = 'ManagedApp',
  ApiUser = 'ApiUser'
}